// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #1351F1;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-screen {
  padding: 20px;
}
.fk-screen .fk-filter-container {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #696969;
  margin: 20px 0 10px 0;
  padding: 0 0 10px 0;
}
.fk-screen .fk-filter-container.--only-filter {
  justify-content: flex-end;
}
.fk-screen .fk-filter-container button {
  display: flex;
  align-items: center;
  padding: 0;
  font: normal normal bold 16px/21px Noto Sans;
  color: #1351F1;
}
.fk-screen .fk-filter-container button:hover {
  background-color: transparent;
  opacity: 0.8;
}
.fk-screen .fk-filter-container button img {
  margin-right: 5px;
}
.fk-screen .fk-filter-container .fk-filter {
  display: flex;
  justify-content: flex-end;
  gap: 25px;
}
.fk-screen .fk-filter-container h3 {
  margin: 0 0 0 10px;
  font: normal normal bold 20px/24px Noto Sans;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/screens/screens.styles.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACI,aAAA;AAgCJ;AA9BI;EACI,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;AAgCR;AA9BQ;EACI,yBAAA;AAgCZ;AA7BQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,4CAAA;EACA,cDbI;AC4ChB;AA7BY;EACI,6BAAA;EACA,YAAA;AA+BhB;AA5BY;EACI,iBAAA;AA8BhB;AA1BQ;EACI,aAAA;EACA,yBAAA;EACA,SAAA;AA4BZ;AAzBQ;EACI,kBAAA;EACA,4CAAA;AA2BZ","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #1351F1;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000; // #ff1744\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../styles/variables';\n\n.fk-screen {\n    padding: 20px;\n\n    .fk-filter-container {\n        display: flex;\n        justify-content: space-between;\n        border-bottom: 1px solid #696969;\n        margin: 20px 0 10px 0;\n        padding: 0 0 10px 0;\n\n        &.--only-filter {\n            justify-content: flex-end;\n        }\n\n        button {\n            display: flex;\n            align-items: center;\n            padding: 0;\n            font: normal normal bold 16px/21px Noto Sans;\n            color: $base-ui-color;\n\n            &:hover {\n                background-color: transparent;\n                opacity: .8;\n            }\n\n            img {\n                margin-right: 5px;\n            }\n        }\n\n        .fk-filter {\n            display: flex;\n            justify-content: flex-end;\n            gap: 25px;\n        }\n\n        h3 {\n            margin: 0 0 0 10px;\n            font: normal normal bold 20px/24px Noto Sans;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
